<template>
    <div class="border-t border-gray-100 p-3 text-right ">
        <NuxtLink
            :to="viewAllUrl"
            class="fulltext-search-view-all-link text-xs font-medium inline-flex items-center transition-colors duration-200 hover:underline focus:outline-none focus:underline"
            @click="handleClick"
        >
            {{ viewAllText }}
            <IconArrowRight class="ml-1" />
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
    import IconArrowRight from '~/components/icons/IconArrowRight.vue';

    type FulltextSearchViewAllLinkProps = {
        viewAllUrl: string;
        viewAllText: string;
    }

    type FulltextSearchViewAllLinkEmits = {
        (e: 'view-all-clicked'): void;
    }
        
    defineProps<FulltextSearchViewAllLinkProps>();
    const emit = defineEmits<FulltextSearchViewAllLinkEmits>();

    const handleClick = () => {
        emit('view-all-clicked');
    };
</script>

<style scoped lang="scss">
    .fulltext-search-view-all-link {
        color: var(--button-color, #3b82f6);
        
        &:hover {
            color: color-mix(in srgb, var(--button-color, #3b82f6) 80%, black);
        }
    }
</style> 
